import { render, staticRenderFns } from "./DaySchedule.vue?vue&type=template&id=22af1123&scoped=true&"
import script from "./DaySchedule.vue?vue&type=script&lang=js&"
export * from "./DaySchedule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22af1123",
  null
  
)

export default component.exports